import { environment } from '../../../../environments/environment';
import * as i0 from "@angular/core";
export class UrlProviderService {
    constructor() {
        this.baseUrl = environment.apiUrl;
    }
    getCountriesURL() {
        return this.baseUrl + '/lookup/getCountries';
    }
    getErpsURL() {
        return this.baseUrl + '/lookup/getERPs';
    }
    getUsageTypesURL() {
        return this.baseUrl + '/lookup/getUsageTypes';
    }
    getTaxOfficesURL() {
        return this.baseUrl + '/lookup/getTaxOffices';
    }
    getCities(countryCode) {
        return this.baseUrl + '/lookup/getCities?countryCode=' + countryCode;
    }
    checkCustomerByIdentifier(identifier) {
        return this.baseUrl + 'onlineApplication/CheckCustomerByIdentifier?Identifier=' + identifier;
    }
    getSubmitApplicationURL(isAgentEdit) {
        return this.baseUrl + 'onlineApplication/submitApplication?isAgentEdit=' + isAgentEdit;
    }
    getCheckCustomerByNviServiceURL() {
        return this.baseUrl + 'onlineApplication/CheckIdentityNumber';
    }
    getGetApplicationURL(uuid, identifier, isMainPrewiew) {
        var parameter = identifier == null ? "" : identifier;
        return this.baseUrl + 'onlineApplication/GetApplication?uuid=' + uuid + '&identifier=' + parameter + '&isMainPrewiew=' + isMainPrewiew;
    }
    checkOnlineApplicationByIdentifier(identifier) {
        return this.baseUrl + 'onlineApplication/CheckOnlineApplicationByIdentifier?Identifier=' + identifier;
    }
    checkOnlineApplicationConfirmationCode(identifier, confirmCode) {
        return this.baseUrl + 'onlineApplication/checkMailConfirmationCode?Identifier=' + identifier + '&confirmCode=' + confirmCode;
    }
    getSaveDraftURL() {
        return this.baseUrl + 'onlineApplication/SaveAsDraft';
    }
    getPurchaseNewProductsURL(uuid) {
        return this.baseUrl + 'onlineApplication/PurchaseNewProduct?uuid=' + uuid;
    }
    getGetApplicationByTokenURL() {
        return this.baseUrl + 'onlineApplication/GetOnlineApplicationByToken';
    }
    approveApplicationURL() {
        return this.baseUrl + 'onlineApplication/ApproveOnlineApplication';
    }
    rejectApplicationURL() {
        return this.baseUrl + 'onlineApplication/RejectOnlineApplication';
    }
    sendApplicationLinkToAgentURL() {
        return this.baseUrl + 'onlineApplication/SendApplicationLinkToAgent';
    }
    updateGibRegistrationDateURL() {
        return this.baseUrl + 'onlineApplication/UpdateGibRegistrationDate';
    }
    sendApplicationLinkToUnitsURL(identifier) {
        return this.baseUrl + 'onlineApplication/sendApplicationLinkToUnits?identifier=' + identifier;
    }
    getApplicationHistoryByUUIDURL(uuid) {
        return this.baseUrl + 'onlineApplication/GetOnlineApplicationHistoryByUUID?uuid=' + uuid;
    }
    sendMailVerificationForNewForm(email, identifier) {
        return this.baseUrl + 'onlineApplication/SendMailVerificationForNewForm?email=' + email + '&identifier=' + identifier;
    }
    sendMailVerificationForPaymentCancel(email) {
        return this.baseUrl + 'onlineApplication/SendMailVerificationForPaymentCancel?email=' + email;
    }
    checkConfirmCodeComparison(confirmCode, encryptedConfirmCode) {
        return this.baseUrl + 'onlineApplication/CheckConfirmCodeComparison?confirmCode=' + confirmCode + '&encryptedConfirmCode=' + encryptedConfirmCode;
    }
    getIdentifierExistCustomer(identifier) {
        return this.baseUrl + 'onlineApplication/GetIdentifierExistCustomer?identifier=' + identifier;
    }
    getCancelInformationByIdentifier(identifier) {
        return this.baseUrl + 'onlineApplication/GetCancelInformationByIdentifier?identifier=' + identifier;
    }
    submitCancelApplication() {
        return this.baseUrl + 'onlineApplication/SubmitCancelApplication';
    }
    updateStatusForNewProducts(identifier, status) {
        return this.baseUrl + 'onlineApplication/UpdateStatusForNewProducts?identifier=' + identifier + '&status=' + status;
    }
    getAliasAndBranchByIdentifier(identifier, appType) {
        return this.baseUrl + 'onlineApplication/GetAliasAndBranchByIdentifier?identifier=' + identifier + '&appType=' + appType;
    }
    cancelOnlineApplication() {
        return this.baseUrl + 'onlineApplication/CancelOnlineApplication';
    }
    charge() {
        return this.baseUrl + 'checkout/Charge';
    }
    tdsInitial() {
        return this.baseUrl + 'checkout/TdsInitial';
    }
    tdsCharge() {
        return this.baseUrl + 'checkout/TdsCharge';
    }
    reversedRequest() {
        return this.baseUrl + 'checkout/ReversedRequest';
    }
    UpdatePaymentSummary() {
        return this.baseUrl + 'onlineApplication/UpdatePaymentSummary';
    }
    CancelPayment() {
        return this.baseUrl + 'onlineApplication/CancelPayment';
    }
    getIsHasContinueCancelApplicationByIdentifier(identifier) {
        return this.baseUrl + 'onlineApplication/IsHasContinueCancelApplication?identifier=' + identifier;
    }
    getPaymentPlansByAgent(agentCode) {
        return this.baseUrl + 'onlineApplication/getPaymentPlansByAgent?agentCode=' + agentCode;
    }
    getAgent(agentCode) {
        return this.baseUrl + 'onlineApplication/GetAgentCredentials?agentCode=' + agentCode;
    }
    getAgentPackages(agentCode, languageCode) {
        return this.baseUrl + 'onlineApplication/GetAgentPackages?agentCode=' + agentCode + '&languageCode=' + languageCode;
    }
    createOnlineApplication(identifier) {
        return this.baseUrl + 'onlineApplication/CreateOnlineApplication?identifier=' + identifier;
    }
    getCustomerBalanceByIdentifierURL(identifier) {
        var parameter = identifier == null ? "" : identifier;
        return this.baseUrl + 'onlineApplication/GetCustomerBalanceByIdentifier?identifier=' + parameter;
    }
    GetCustomerPartnersByIdentifierURL(identifier) {
        var parameter = identifier == null ? "" : identifier;
        return this.baseUrl + 'onlineApplication/GetCustomerPartnersByIdentifier?identifier=' + parameter;
    }
    SendCustomerNewBalance() {
        return this.baseUrl + 'onlineApplication/SendCustomerNewBalance';
    }
    SetCustomerMembership() {
        return this.baseUrl + 'onlineApplication/SetCustomerMembership';
    }
    loginWithPortalUser(code) {
        return this.baseUrl + 'onlineApplication/LoginOnlineApplicationWithPortalUser?code=' + code;
    }
    getCustomerPartners(identifier) {
        return this.baseUrl + 'onlineApplication/GetCustomerPartners?identifier=' + identifier;
    }
}
UrlProviderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UrlProviderService_Factory() { return new UrlProviderService(); }, token: UrlProviderService, providedIn: "root" });
